import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';

// Lazy-loaded components (same components, new routes)
const Programs = React.lazy(() => import('@/modules/academic/curriculum/programs/Programs'));
const HubCalendarioPage = React.lazy(() => import('@/modules/hub/calendar/HubCalendarioPage'));
const OrgChartViewer = React.lazy(() => import('@/modules/hr/personal/OrgChartViewer'));
const TasksPage = React.lazy(() => import('@/modules/system/procedimientos/components/TasksTab'));

export const knowledgeRoutes = [
  <Route key="/base-conocimiento/catalogo" path="/base-conocimiento/catalogo" element={
    <ProtectedRoute requiredPermission="knowledge.catalog.view"><Programs /></ProtectedRoute>
  } />,
  <Route key="/base-conocimiento/calendario" path="/base-conocimiento/calendario" element={
    <ProtectedRoute requiredPermission="knowledge.calendar.view"><HubCalendarioPage /></ProtectedRoute>
  } />,
  <Route key="/base-conocimiento/organigrama" path="/base-conocimiento/organigrama" element={
    <ProtectedRoute requiredPermission="knowledge.catalog.view"><OrgChartViewer /></ProtectedRoute>
  } />,
  // Mis Tareas — accesible para admin y docentes (no alumnos/corporaciones)
  <Route key="/hub/tareas" path="/hub/tareas" element={
    <ProtectedRoute requiredPermission="knowledge.catalog.view"><TasksPage standalone /></ProtectedRoute>
  } />,
];
